import { Component, OnInit } from '@angular/core';
import {OverlayConfig, OverlayRef} from 'exc-controls';
import {ExcTranslation} from 'exc-core';

@Component({
  selector: 'app-modal-audit-pin-changed',
  templateUrl: './modal-audit-pin-changed.component.html',
  styles: []
})
export class ModalAuditPinChangedComponent extends ExcTranslation implements OnInit {

  constructor(private overlayConfig: OverlayConfig, private overlayRef: OverlayRef) {
    super();
  }

  ngOnInit() {
  }

}
